// extracted by mini-css-extract-plugin
module.exports = {"user":"User_user__7BKvz","input":"User_input__1kRPc","button":"User_button__1Sq6C"};